"use client";

export interface BuildCardProps {
  title: string;
  description: string;
  iconSrc?: string; // optional sport icon
  theme?: "blue" | "pink";
}

export default function BuildCard({
  title,
  description,
  iconSrc,
  theme = "blue",
}: BuildCardProps) {
  const accentClasses =
    theme === "pink"
      ? {
          overlay:
            "bg-[linear-gradient(180deg,rgba(255,240,246,0.98)_0%,rgba(255,224,235,0.72)_32%,rgba(255,205,224,0.28)_58%,rgba(255,205,224,0)_100%)]",
          glow: "bg-[#ffd0e0]/85",
          corner:
            "bg-[linear-gradient(135deg,rgba(255,91,146,0.22),rgba(255,255,255,0))]",
          title: "text-[#c13b74]",
        }
      : {
          overlay:
            "bg-[linear-gradient(180deg,rgba(228,236,255,0.98)_0%,rgba(228,236,255,0.72)_32%,rgba(228,236,255,0.28)_58%,rgba(228,236,255,0)_100%)]",
          glow: "bg-[#ebe8ff]/80",
          corner:
            "bg-[linear-gradient(135deg,rgba(79,124,255,0.18),rgba(255,255,255,0))]",
          title: "text-[#2a37b8]",
        };

  return (
    <article className="relative min-h-[19.5rem] overflow-hidden rounded-[1.6rem] bg-white px-7 pb-8 pt-8 shadow-[0_22px_48px_rgba(34,50,120,0.05)] transition-transform duration-200 hover:-translate-y-1 sm:min-h-[20.5rem] sm:px-8 sm:pb-9 sm:pt-9">
      <div aria-hidden className={`absolute inset-0 ${accentClasses.overlay}`} />
      <div
        aria-hidden
        className={`absolute -right-8 -top-8 h-36 w-36 rounded-full blur-3xl ${accentClasses.glow}`}
      />
      <div
        aria-hidden
        className={`absolute bottom-0 left-0 h-20 w-20 rounded-tr-[2.5rem] ${accentClasses.corner}`}
      />

      <div className="relative z-10 flex h-full flex-col">
        {iconSrc && (
          <img
            src={iconSrc}
            alt=""
            className="mb-5 h-10 w-10 opacity-80"
          />
        )}
        <h4
          className={`max-w-[13rem] whitespace-pre-line font-clash text-[1.55rem] font-semibold uppercase leading-[0.96] tracking-[0.045em] sm:text-[1.8rem] ${accentClasses.title}`}
        >
          {title}
        </h4>
        <p className="mt-5 flex-1 text-[1.02rem] leading-[1.7] text-[#161922] sm:text-[1.04rem] sm:leading-[1.72]">
          {description}
        </p>
      </div>
    </article>
  );
}
